var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 12L7.29289 11.2929L6.58579 12L7.29289 12.7071L8 12ZM20 13C20.5523 13 21 12.5523 21 12C21 11.4477 20.5523 11 20 11L20 12L20 13ZM14 6L13.2929 5.29289L7.29289 11.2929L8 12L8.70711 12.7071L14.7071 6.70711L14 6ZM8 12L7.29289 12.7071L13.2929 18.7071L14 18L14.7071 17.2929L8.70711 11.2929L8 12ZM8 12L8 13L20 13L20 12L20 11L8 11L8 12Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
